import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
});

// Add token to every request
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('auth_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// EPK API
export const createEPK = (data) => api.post('/epks', data);
export const listEPKs = (status) => api.get('/epks', { params: status ? { status } : {} });
export const getEPK = (id) => api.get(`/epks/${id}`);
export const updateEPK = (id, data) => api.put(`/epks/${id}`, data);
export const updateEPKStatus = (id, status) => api.patch(`/epks/${id}/status`, { status });
export const deleteEPK = (id) => api.delete(`/epks/${id}`);
// Public EPK - no auth needed, plain request
export const getPublicEPK = (slug) => axios.get(`${API}/public/epk/${slug}`);

// Upload
export const uploadImage = async (file) => {
  const formData = new FormData();
  formData.append('file', file);
  const { data } = await api.post('/upload/image', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return data;
};

// File URL helper
export const getFileUrl = (storagePath) => `${API}/files/${storagePath}`;

export default api;
